export default "__VITE_ASSET__Qa5WwTSL__"